import apiClient, { type PagedResponse } from '../client'
import type {
  AcceptReconciliationRequest,
  ReconciliationDetailResponse,
  ReconciliationListItemResponse,
  RejectReconciliationRequest,
} from '../models/response'

const BASE_PATH = '/conciliacion'

export const conciliacionService = {
  async getAll(params?: {
    page?: number
    pageSize?: number
    search?: string
    decision?: 'Pendiente' | 'Aceptada' | 'Rechazada'
  }): Promise<PagedResponse<ReconciliationListItemResponse>> {
    return apiClient.get<PagedResponse<ReconciliationListItemResponse>>(BASE_PATH, params)
  },

  async getDetail(shipmentId: string): Promise<ReconciliationDetailResponse> {
    return apiClient.get<ReconciliationDetailResponse>(`${BASE_PATH}/${shipmentId}`)
  },

  async aceptar(shipmentId: string, data: AcceptReconciliationRequest = {}): Promise<boolean> {
    return apiClient.post<boolean, AcceptReconciliationRequest>(
      `${BASE_PATH}/${shipmentId}/aceptar`,
      data,
    )
  },

  async rechazar(shipmentId: string, data: RejectReconciliationRequest): Promise<boolean> {
    return apiClient.post<boolean, RejectReconciliationRequest>(
      `${BASE_PATH}/${shipmentId}/rechazar`,
      data,
    )
  },
}
